import Decimal from 'break_eternity.js';

export { Decimal };
export type DecimalSource = Decimal | number | string;

export const D = (v: DecimalSource): Decimal => new Decimal(v);
export const ZERO = new Decimal(0);
export const ONE = new Decimal(1);

export function dSerialize(d: Decimal): string {
  return d.toString();
}

export function dParse(s: string | number | undefined | null): Decimal {
  if (s === undefined || s === null || s === '') return new Decimal(0);
  const d = new Decimal(s);
  return Number.isFinite(d.sign) && !Number.isNaN(d.mag) ? d : new Decimal(0);
}

export function dMax(a: Decimal, b: Decimal): Decimal {
  return a.gte(b) ? a : b;
}

export function dMin(a: Decimal, b: Decimal): Decimal {
  return a.lte(b) ? a : b;
}

/** Floor to an integer amount of coins. */
export function dFloor(d: Decimal): Decimal {
  return d.floor();
}

export function dEq(a: Decimal, b: Decimal): boolean {
  return a.eq(b);
}

/** Lossy conversion for places where a plain number is fine (UI tiers, ratios). */
export function dToNumber(d: Decimal): number {
  const n = d.toNumber();
  return Number.isFinite(n) ? n : d.sign >= 0 ? Number.MAX_VALUE : -Number.MAX_VALUE;
}
